module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Gauge2_16"],"path":[{"$":{"d":"M15,10v1H12V10h1.58A6.1,6.1,0,0,0,8,4.23V6H7V4.23A6.1,6.1,0,0,0,1.42,10H3v1H0V10H0a7.49,7.49,0,0,1,15,0ZM10.89,7.17,6,12.5V14H7.5l3.93-6.43Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Gauge2_16.svg
// module id = QSkV
// module chunks = 1